<div class="container">
  <div class="header-group">
    <h1>UZURV</h1>
    <button
      id="organizationRiderDetail-button-edit"
      mat-raised-button
      (click)="handleEditRiderButtonClicked()"
      *appRequiresPermissions="{ any: ['rider_update'] }"
    >
      <mat-icon>edit</mat-icon>
      Edit
    </button>
  </div>

  <div class="rider-info">
    <div class="first-colum">
      <small id="organizationRiderDetail-label-profileCreateLabel">Profile Created</small>
      <p id="organizationRiderDetail-text-profileCreated">{{ rider.createdDate | date : 'medium' }}</p>

      <small>Email Address</small>
      <p id="uzurvRiderProfile-text-emailAddress" data-private>{{ rider?.emailAddress ? rider.emailAddress : 'Not set' }}</p>

      <small id="uzurvRiderProfile-label-phone">Phone</small>
      <p id="uzurvRiderProfile-text-phone">{{ rider?.phoneNumber | phone }}</p>

      <small id="uzurvRiderProfile-label-textMessageAlerts">Text Message Alerts</small>
      <p id="uzurvRiderProfile-text-textMessageAlerts">{{ rider.smsEnabledPhone ? 'Yes' : 'No' }}</p>

      <small>Address</small>
      <ng-container *ngIf="riderAddress; else noAddress">
        <p id="address-line-one">
          {{ riderAddress.streetAddress1 + (riderAddress.streetAddress2 ? ' ' + riderAddress.streetAddress2 : '') }}
        </p>
        <p id="address-line-two">
          {{ riderAddress.city ? riderAddress.city + ',' : null }} {{ riderAddress.stateCode }}
          {{ riderAddress.zipCode }}
        </p>
      </ng-container>
      <ng-template #noAddress><p id="organizationRiderDetail-text-noAddressOnFile">No address on file</p></ng-template>
    </div>
    <div>
      <ng-container *ngIf="rider.dateOfBirth; else ageNotSet">
        <small>Date of Birth</small>
        <p id="uzurvRiderProfile-text-dateOfBirth" data-private>
          {{ rider?.dateOfBirth ? getFormattedDateOfBirth(rider?.dateOfBirth) : 'Not set' }}
        </p>
        <small>Age</small>
        <p id="uzurvRiderProfile-text-age">
          <span *ngIf="!riderOver18" id="uzurvRiderProfile-span-minorWarning" class="warning-text">MINOR - </span>
          {{ riderOver18 ? 'Over 18' : riderAge + ' years old' }}
        </p>
      </ng-container>

      <ng-template #ageNotSet>
        <small>Age</small>
        <p id="uzurvRiderProfile-text-dateOfBirthNotSet">Not set</p>
      </ng-template>

      <ng-container *ngIf="isOrganizationRiderAppEnabled">
        <small>Rider App Download</small>
        <button id="uzurvRider-button-uzurvRideInvite" mat-stroked-button color="primary" (click)="handleSendUzurvRideAppInvitation()">
          Send link by text message
        </button>
        <br />
        <p id="organizationRiderDetail-text-uzurvRideInvite">
          This link will help the rider sign up for the app by pre-populating a few registration fields
        </p>
      </ng-container>
    </div>
  </div>
</div>
